var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-form-item",
    { attrs: { label: _vm.element.caption, prop: _vm.element.key } },
    [
      _c("q-composite-list", {
        attrs: {
          "structure-key": _vm.element.listStructureKey,
          disabled: _vm.element.disabled,
        },
        model: {
          value: _vm.model[_vm.element.key],
          callback: function ($$v) {
            _vm.$set(_vm.model, _vm.element.key, $$v)
          },
          expression: "model[element.key]",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }